import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupFixedAsset } from "../../../Shared/NewForms/NFLookupFixedAsset";
import { NFLookupConstructionObject } from "../../../Shared/NewForms/NFLookupConstructionObject";

export const FixedAssetsWriteOffsDetailsProducts = () => {
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"fixedAssets"}>
                <NFTextInput fieldName="lineNo" title={t("#")} />
                <NFLookupFixedAsset
                    fieldName={"fixedAssetId"}
                    title={t("FixedAsset")}
                />
                <NFLookupFixedAsset
                    title={t("fixed Assets WriteOff Id")}
                    fieldName="fixedAssetsWriteOffId"
                />
            </NFormTable>
        </>
    );
};
